<div class="content">
  <div class="selectors-box flex column">
    <!-- Search filter -->
    <div class="selector-row flex vcenter">
      <payee-form-field>
        <input
          payee-input
          [formControl]="nameFormControl"
        />
        <span payee-label>Értesítés neve</span>
      </payee-form-field>
      @if (tableLoading) {
        <mat-progress-spinner
          color="accent"
          diameter="24"
          class="table-loading-spinner"
          mode="indeterminate"
        ></mat-progress-spinner>
      }

      <payee-form-field>
        <input
          payee-input
          [formControl]="payeeCaseReferenceId"
        />
        <span payee-label>Előnézet ügy azonosító</span>
      </payee-form-field>
      @if (previewLoading.size > 0) {
        <mat-progress-spinner
          color="accent"
          diameter="24"
          class="table-loading-spinner"
          mode="indeterminate"
        ></mat-progress-spinner>
      }

      <div class="flex attachment-box">
        <payee-dropzone
          title="Előnézet csatolmányok"
          description=""
          [multiple]="true"
          (dropped)="filesDropped($event)"
        ></payee-dropzone>

        <div class="flex column">
          @for (file of files; track file; let i = $index) {
            <div class="flex vcenter file">
              <span class="file-name">{{ file.name }}</span>
              <button
                payee-mini-icon-button
                color="white"
                (click)="files.splice(i, 1)"
              >
                <payee-icon name="trash-red"></payee-icon>
              </button>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="selector-row flex vcenter">
      <button
        payee-button
        (click)="createNotification()"
      >
        Új értesítés
      </button>
    </div>
  </div>

  <table
    mat-table
    custom-table
    multiTemplateDataRows
    matSort
    class="mat-elevation-z1"
    [dataSource]="dataSource"
    (matSortChange)="sortData($event)"
  >
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        Név
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.name }}
      </td>
    </ng-container>

    <!-- Languages Column -->
    <ng-container matColumnDef="languages">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Nyelvek
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        @for (lang of element.langs | keyvalue; track lang.key) {
          <span matTooltipPosition="above">
            {{ $any(lang.key) | countryFlag }}
          </span>
        }
      </td>
    </ng-container>

    <!-- Preview Column -->
    <ng-container matColumnDef="preview">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Előnézet
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <button
          payee-button
          width="shorter"
          height="short"
          matTooltipPosition="above"
          [disabled]="previewLoading.has(element.id) || !payeeCaseReferenceId.value"
          [matTooltip]="'Előnézet email küldése a jelenlegi felhasználónak'"
          (click)="previewNotification(element)"
        >
          @if (previewLoading.has(element.id)) {
            <mat-spinner
              diameter="16"
              color="accent"
              class="inline-spinner"
            ></mat-spinner>
          }
          @if (!previewLoading.has(element.id)) {
            <span>Email küldése</span>
          }
          @if (previewLoading.has(element.id)) {
            <span>Küldés...</span>
          }
        </button>
      </td>
    </ng-container>

    <!-- Edit Column -->
    <ng-container matColumnDef="edit">
      <th
        *matHeaderCellDef
        mat-header-cell
      ></th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <button
          payee-button
          width="shorter"
          height="short"
          (click)="editNotification(element)"
        >
          Szerkesztés
        </button>
      </td>
    </ng-container>

    <!-- Delete Column -->
    <ng-container matColumnDef="delete">
      <th
        *matHeaderCellDef
        mat-header-cell
      ></th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <button
          payee-button
          width="shorter"
          height="short"
          color="alert-red"
          (click)="deleteNotification(element)"
        >
          Törlés
        </button>
      </td>
    </ng-container>

    <tr
      *matHeaderRowDef="displayedColumns"
      mat-header-row
    ></tr>
    <tr
      *matRowDef="let row; columns: displayedColumns"
      mat-row
    ></tr>
  </table>

  <mat-paginator
    showFirstLastButtons
    [length]="length"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="[5, 10, 25, 50]"
    (page)="pageChange($event)"
  ></mat-paginator>
</div>
